// Man Quan tri he thong > Tich hop TaskGov. Goi qlvb-be (token qlvb-be nhu API thuong, xem src/api/http-common.js).
// Tham so qua axios params de duoc ma hoa URL (TraceId, tai khoan, IP do nguoi dung nhap).
import ENDPOINT from "@/api/endpoints";
import { HTTP } from "@/api/http-common";

function boGiaTriRong(params) {
  const ketQua = {};
  Object.keys(params || {}).forEach((key) => {
    const value = params[key];
    if (value !== null && value !== undefined && value !== "") ketQua[key] = value;
  });
  return ketQua;
}

/**
 * Nhat ky TaskGov goi eDoc (E1-E5), moi nhat truoc.
 * @param {{TuNgay?: string, DenNgay?: string, Api?: string, Nhom?: number, Username?: string, ClientIp?: string,
 *   TraceId?: string, FileId?: string, EdocTaskId?: string, PageIndex: number, PageSize: number}} payload
 */
export function callApiLayNhatKyTaskGovGoiEdoc(payload) {
  return HTTP.get(ENDPOINT.TASKGOV.NHAT_KY_VAO, { params: boGiaTriRong(payload) });
}

/**
 * Du lieu JSON eDoc da tra cho 1 loi goi E1-E3 (phan trang + loc o BE).
 * @param {number} id Id dong nhat ky
 * @param {{tuKhoa?: string, isDeleted?: boolean, pageIndex: number, pageSize: number}} params
 */
export function callApiLayDuLieuEdocDaTra(id, params) {
  return HTTP.get(ENDPOINT.TASKGOV.NHAT_KY_VAO_DU_LIEU(id), { params: boGiaTriRong(params) });
}

/** Tai nguyen ban JSON goc (blob) qua client co token. */
export function callApiTaiDuLieuEdocDaTra(id) {
  return HTTP.get(ENDPOINT.TASKGOV.NHAT_KY_VAO_DU_LIEU_TAI(id), { responseType: "blob" });
}

/** Tong hop theo endpoint: so luot, so bi tu choi, so loi, trung vi va p95 thoi luong. */
export function callApiTongHopNhatKyTaskGovGoiEdoc(payload) {
  return HTTP.get(ENDPOINT.TASKGOV.NHAT_KY_VAO_TONG_HOP, { params: boGiaTriRong(payload) });
}

/**
 * Goi truoc khi hien o "Giao viec (chuyen sang TaskGov)" (modal phan xu ly) va truoc khi goi trang-thai.
 * Loi hoac co tat: tra { Enabled: false, CoTheGiaoViecTaskGov: false }, khong chan mo modal/tai danh sach.
 * @returns {Promise<{Enabled: boolean, CoTheGiaoViecTaskGov: boolean}>}
 */
export function callApiLayCauHinhTaskGov() {
  return HTTP.get(ENDPOINT.TASKGOV.CAU_HINH);
}

/**
 * Cot "Trang thai giao viec" o danh sach van ban den (tab Dang xu ly, Da xu ly). Goi sau khi tai 1 trang.
 * @param {{Items: Array<{ProcessId: string, TaskId: string}>}} payload toi da 200 cap
 */
export function callApiLayTrangThaiGiaoViecTaskGov(payload) {
  return HTTP.post(ENDPOINT.TASKGOV.TRANG_THAI, payload);
}

/** Khoi lich su giao viec TaskGov o chi tiet van ban den (W3). */
export function callApiLayLichSuGiaoViecTaskGov(processId) {
  return HTTP.get(ENDPOINT.TASKGOV.LICH_SU(processId));
}

/**
 * Nut "Gui lai". Toi da 100 id. Chi xep lenh, ket qua that den sau qua trang-thai/lich-su/thong bao.
 * @param {{EdocTaskIds: string[]}} payload
 */
export function callApiGuiLaiGiaoViecTaskGov(payload) {
  return HTTP.post(ENDPOINT.TASKGOV.GUI_LAI, payload);
}

/**
 * Man quan tri, tab "Giao viec": danh sach loc theo trang thai, loi, don vi, khoang ngay, phan trang.
 * @param {{TrangThai?: number, CoLoi?: boolean, DonViId?: string, TuNgay?: string, DenNgay?: string,
 *   PageIndex: number, PageSize: number}} payload
 */
export function callApiDanhSachGiaoViecTaskGov(payload) {
  return HTTP.get(ENDPOINT.TASKGOV.GIAO_VIEC, { params: boGiaTriRong(payload) });
}

/**
 * Man quan tri, tab "eDoc goi TaskGov": nhat ky chieu ra (E1-E5 la chieu vao, khac API nay).
 * @param {{Api?: string, KetQua?: string, Success?: boolean, EdocTaskId?: string, TuNgay?: string,
 *   DenNgay?: string, PageIndex: number, PageSize: number}} payload
 */
export function callApiLayNhatKyTaskGovGoiRa(payload) {
  return HTTP.get(ENDPOINT.TASKGOV.NHAT_KY_RA, { params: boGiaTriRong(payload) });
}

/**
 * Man quan tri, tab "eDoc goi TaskGov": request da gui (method, URL, header da che khoa, payload) va response.
 * @param {number} id Id dong nhat ky
 */
export function callApiLayChiTietNhatKyTaskGovGoiRa(id) {
  return HTTP.get(ENDPOINT.TASKGOV.NHAT_KY_RA_CHI_TIET(id));
}

/**
 * Man quan tri, tab "eDoc goi TaskGov": tra ket qua lan Dong bo danh muc tai TaskGov (API sync-errors) theo RequestId
 * cua dong nhat ky. BE goi TaskGov moi lan bam, khong luu ket qua.
 * @param {number} id Id dong nhat ky (lenh DongBoDanhMuc co RequestId)
 */
export function callApiLayKetQuaDongBoTaskGov(id) {
  return HTTP.get(ENDPOINT.TASKGOV.NHAT_KY_RA_KET_QUA_DONG_BO(id));
}

/**
 * Man quan tri, tab "Dong bo va kich hoat": danh sach can bo de kich hoat tai khoan TaskGov.
 * @param {{DonViId?: string, TuKhoa?: string, TrangThaiKichHoat?: number, PageIndex: number, PageSize: number}} payload
 */
export function callApiDanhSachCanBoTaskGov(payload) {
  return HTTP.get(ENDPOINT.TASKGOV.CAN_BO, { params: boGiaTriRong(payload) });
}

/**
 * Kich hoat tai khoan TaskGov cho toi da 100 can bo.
 * @param {{CanBoIds: string[]}} payload
 */
export function callApiKichHoatTaiKhoanTaskGov(payload) {
  return HTTP.post(ENDPOINT.TASKGOV.KICH_HOAT, payload);
}

/**
 * Dong bo danh muc sang TaskGov. Rong nghia la ca 3 danh muc.
 * @param {{Categories: string[]}} payload
 */
export function callApiDongBoDanhMucTaskGov(payload) {
  return HTTP.post(ENDPOINT.TASKGOV.DONG_BO, payload);
}
